import * as yup from 'yup'
import { CompanyAddressDto } from './companyAddressDto'
import { VehicleDto, PersonDto, VehicleRecallRepairStatusDto, VehicleRecallStatusDto, CompanyDto } from 'dtos'

export class VehicleRecallDto {
  vehicleRecallGuid?: string = undefined
  vehicleRecallStatus?: VehicleRecallStatusDto = undefined
  recallCampaignId?: string = undefined
  recallDescription?: string = undefined
  recallCountry?: string = undefined
  repairCountry?: string = undefined
  repairLocationAddress?: CompanyAddressDto = undefined
  vehicleRecallRepairStatus?: VehicleRecallRepairStatusDto = undefined
  canadianOEMSiteScreenshotFileName?: string = undefined
  canadianOEMSiteURL?: string = undefined
  usaOEMSiteScreenshotFileName?: string = undefined
  usaOEMSiteURL?: string = undefined
  repairOrderFileName?: string = undefined
  remedyDateTime?: string = undefined
  repairedDateTime?: string = undefined
  createdBy?: PersonDto = undefined
  createdDateTime?: string = undefined
  vehicle?: VehicleDto = undefined
  isActive?: boolean = undefined
  canadianOEMSiteScreenshotFile?: File = undefined
  usaOEMSiteScreenshotFile?: File = undefined
  repairOrderFile?: File = undefined

  vin?: string = undefined
  year?: number = undefined
  make?: string = undefined
  model?: string = undefined

  exporterComany?: CompanyDto = undefined
  buyerCompany?: CompanyDto = undefined
}

export const vehicleRecallValidationSchema = yup.object<VehicleRecallDto>({
  vehicleRecallGuid: yup.string().nullable(),
  vehicleRecallId: yup.string().nullable(),
  vehicleRecallStatus: yup.object().required('Recall / No Recall is required.'),
  recallCampaignId: yup
    .string()
    .nullable()
    .when('vehicleRecallStatus.specialIdentifier', {
      is: 'RECALL', // Only required if the status is 'RECALL'
      then: schema => schema.required('Recall Campaign ID is required.')
    }),
  recallDescription: yup
    .string()
    .nullable()
    .when('vehicleRecallStatus.specialIdentifier', {
      is: 'RECALL', // Only required if the status is 'RECALL'
      then: schema =>
        schema
          .required('Recall Campaign Description is required.')
          .max(2_000, 'Recall Description cannot be more than 2,000 characters.')
    }),
  recallCountry: yup.string().oneOf(['USA', 'Canada'], 'Recall Country must be USA or Canada.').nullable(),
  repairCountry: yup.string().oneOf(['USA', 'Canada'], 'Repair Country must be USA or Canada.').nullable(),
  repairLocationAddress: yup
    .object()
    .nullable()
    .when('repairCountry', {
      is: 'USA',
      then: schema => schema.required('Repair Location is required.')
    }),
  vehicleRecallRepairStatus: yup
    .object()
    .nullable()
    .when('vehicleRecallStatus.specialIdentifier', {
      is: 'RECALL', // Only required if the status is 'RECALL'
      then: schema => schema.required('Repair Status is required.')
    }),
  canadianOEMSiteScreenshotFile: yup
    .mixed()
    .nullable()
    .when(['vehicleRecallStatus.specialIdentifier', 'canadianOEMSiteScreenshotFileName'], {
      is: (vehicleRecallStatusSpecialIdentifier: any, canadianOEMSiteScreenshotFileName: any) =>
        vehicleRecallStatusSpecialIdentifier === 'NO_RECALL' && !canadianOEMSiteScreenshotFileName,
      then: schema => schema.required('Canadian OEM Site Screenshot is required.')
    }),
  canadianOEMSiteURL: yup.string().max(2_083, 'Canadian OEM Site URL cannot be more than 2,083 characters.').nullable(),
  usaOEMSiteScreenshotFile: yup
    .mixed()
    .nullable()
    .when(['vehicleRecallStatus.specialIdentifier', 'usaOEMSiteScreenshotFileName'], {
      is: (vehicleRecallStatusSpecialIdentifier: any, usaOEMSiteScreenshotFileName: any) =>
        vehicleRecallStatusSpecialIdentifier === 'NO_RECALL' && !usaOEMSiteScreenshotFileName,
      then: schema => schema.required('USA OEM Site Screenshot is required.')
    }),
  usaOEMSiteURL: yup.string().max(2_083, 'USA OEM Site URL cannot be more than 2,083 characters.').nullable(),
  repairOrderFile: yup
    .mixed()
    .nullable()
    .when(
      ['vehicleRecallRepairStatus.specialIdentifier', 'repairOrderFileName'],
      ([vehicleRecallRepairStatusSpecialIdentifier, repairOrderFileName], schema) => {
        return vehicleRecallRepairStatusSpecialIdentifier === 'REPAIRED' && !repairOrderFileName
          ? schema.required('Repair Order (RO) is required.')
          : schema.nullable()
      }
    )
})
